import { safeJSONParse } from "core/model/utils/strings";
import {
  AuctionForm,
  DocsFormDataMapped,
  DocsFormName,
  DocsSubmittedFormData,
} from "core/types";
import { FORM_NAME_TO_FILE_TYPE } from "dsl/ecosystems/RecareDocs/Modal/utils";
import { convertEncryptedFieldIn } from "react-forms-state/src/FormUtils";

export const getAuctionForm = ({
  auctionForms,
  formName,
}: {
  formName: DocsFormName;
  auctionForms: AuctionForm[];
}) => {
  const form = formName
    ? auctionForms?.find(
        (auctionForm) =>
          auctionForm.form_type === FORM_NAME_TO_FILE_TYPE[formName],
      )
    : undefined;

  const stringified = form
    ? convertEncryptedFieldIn(form.form_data as Record<string, any>)
    : undefined;

  const [_, parsedFormData] =
    safeJSONParse<DocsSubmittedFormData<typeof formName>>(stringified);

  // Discharge letters are saved with a { values: {...} } wrapper.
  // Rehab forms (GKV/DRV) are saved as raw JSON without the wrapper.
  const formData =
    parsedFormData?.values ??
    (parsedFormData as DocsFormDataMapped<typeof formName> | null | undefined);

  return {
    form,
    formData,
    metadata: form?.metadata,
  };
};
